module.exports = __webpack_public_path__ + "assets/img/qrcode.f91230e8.png";